<!-- with a job app (app.jobsTab) both apps stay alive; the main tabs only show one of them, and a
     pupil sees the job app alone (but the start page as everyone does) -->
<div
  class="app-frame"
  [class.frame-only]="fairTabs.pupil() && fairTabs.frameShown()"
  [class.with-tabs]="fairTabs.showTabs()"
>
  @if (!isReloadWithId) {
    <div class="strand" [class.gone]="fairTabs.frameShown()">
      <router-outlet />
    </div>
  }
  @if (fairTabs.jobsFrameSrc(); as src) {
    <iframe
      [class.gone]="!fairTabs.frameShown()"
      [src]="src | safe: 'resourceUrl'"
      [title]="fairTabs.config?.jobsLabel ?? ''"
      class="strand jobs-frame"
      data-testid="jobs-frame"
    ></iframe>
  }
  @if (fairTabs.showTabs()) {
    <!-- one switch between the two apps, so it reads as a level above each app's own tabs -->
    <nav class="main-tabs" data-testid="main-tabs">
      <div class="switch" role="tablist">
        <button
          (click)="fairTabs.showFair()"
          [attr.aria-selected]="!fairTabs.jobsActive()"
          [class.pulse]="fairTabs.fairHint()"
          [class.selected]="!fairTabs.jobsActive()"
          data-testid="main-tab-fair"
          role="tab"
          type="button"
        >
          <mat-icon>storefront</mat-icon>
          <span>{{ fairTabs.config?.fairLabel }}</span>
        </button>
        <button
          (click)="fairTabs.showJobs()"
          [attr.aria-selected]="fairTabs.jobsActive()"
          [class.pulse]="fairTabs.hint()"
          [class.selected]="fairTabs.jobsActive()"
          data-testid="main-tab-jobs"
          role="tab"
          type="button"
        >
          <mat-icon>work</mat-icon>
          <span>{{ fairTabs.config?.jobsLabel }}</span>
        </button>
      </div>
    </nav>
    @if (fairTabs.hint()) {
      <div class="tab-hint" data-testid="jobs-hint">
        <img [src]="mascot.pointer" alt="" />
        <button (click)="fairTabs.showJobs()" class="bubble" type="button">
          {{ fairTabs.config?.hint?.text }}
        </button>
        <button
          (click)="fairTabs.dismissHint()"
          [attr.aria-label]="'COMMON.close' | translate"
          class="close"
          data-testid="jobs-hint-close"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
    @if (fairTabs.fairHint()) {
      <div class="tab-hint toward-fair" data-testid="fair-hint">
        <img [src]="mascot.pointer" alt="" />
        <button (click)="fairTabs.showFair()" class="bubble" type="button">
          {{ fairTabs.config?.hint?.fairText }}
        </button>
        <button
          (click)="fairTabs.dismissFairHint()"
          [attr.aria-label]="'COMMON.close' | translate"
          class="close"
          data-testid="fair-hint-close"
          type="button"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  }
</div>

@if (isIdle) {
  <recrewt-mascot-dialog
    [buttonTemplate]="dialogButtons"
    [dismissable]="false"
    [priority]="mascotPriority.SYSTEM"
    message="COMMON.idle"
  />
}

<ng-template #dialogButtons>
  @if (handOffLink) {
    <div class="m-t-2" fxLayout="column" fxLayoutAlign="center center" data-testid="idle-hand-off">
      <p class="mat-subtitle-2 text-align-center">{{ 'KIOSK.take_list' | translate }}</p>
      <recrewt-qr-code [data]="handOffLink" [size]="160" />
    </div>
  }
  <div
    class="m-t-2 m-b-1"
    fxLayout="row"
    fxLayout.lt-lg="column"
    fxLayoutAlign="center center"
    fxLayoutGap="0px"
    fxLayoutGap.lt-lg="8px"
  >
    <button (click)="logout()" class="capitalize m-l-2 m-r-2 rounded-button" mat-raised-button>
      <span>{{ 'COMMON.logout' | translate }}!</span>
    </button>
    <button
      (click)="reset()"
      class="capitalize m-l-2 m-r-2 rounded-button"
      color="primary"
      mat-raised-button
    >
      <span>{{ 'COMMON.continue' | translate }}</span>
    </button>
  </div>
</ng-template>

@if (isReloadWithId) {
  <recrewt-mascot-dialog
    [buttonTemplate]="reloadDialogButtons"
    [dismissable]="false"
    [priority]="mascotPriority.SYSTEM"
    message="RESTART.message"
  />
}

<ng-template #reloadDialogButtons>
  <div
    class="m-t-2 m-b-1"
    fxLayout="row"
    fxLayout.lt-lg="column"
    fxLayoutAlign="center center"
    fxLayoutGap="0px"
    fxLayoutGap.lt-lg="8px"
  >
    <button (click)="logout()" class="m-l-2 m-r-2 rounded-button" mat-raised-button tabindex="1">
      <span>{{ 'RESTART.yes' | translate }}!</span>
    </button>
    <button
      color="primary"
      (click)="isReloadWithId = false; reset()"
      class="capitalize m-l-2 m-r-2 rounded-button"
      mat-raised-button
      tabindex="0"
    >
      <span>{{ 'COMMON.continue' | translate }}</span>
    </button>
  </div>
</ng-template>
